var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"yellow"}),_vm._v(" "),_c('div',{staticClass:"red"}),_vm._v(" "),_c('div',{staticClass:"blue"}),_vm._v(" "),_c('div',{staticClass:"violet"})])
}]

export { render, staticRenderFns }